import { defineStore } from "pinia";

import {
  getHoteluxCuratedCollections,
  getHoteluxHomeEntries,
  getHoteluxPopularDestinations
} from "@/api/hoteluxHome";
import { store } from "@/store";

const DEFAULT_HOTEL_IDS = [
  "5b35eb5021b146b104fd6266",
  "5b5077616a8860a3024e09d4",
  "5b5964218885d57e94df4c33",
  "5b35e54d74b5e5b4a112b33c",
  "5b50e50312bd3f60197ea5a2",
  "5b5073eb6a8860a3024de474"
];

const DEFAULT_SECTION_TITLES = {
  exclusiveOffers: {
    zh_CN: "独家优惠",
    zh_TW: "獨家優惠",
    en: "Exclusive Offers",
    jp: "限定オファー"
  },
  curatedCollections: {
    zh_CN: "精选酒店",
    zh_TW: "精選飯店",
    en: "Curated Collections",
    jp: "厳選コレクション"
  }
};

export const useHoteluxHomeStore = defineStore({
  id: "consumer-y-hotelux-home",
  state: () => ({
    loading: false,
    banners: [],
    exclusiveOffers: [],
    curatedHotelIds: [...DEFAULT_HOTEL_IDS],
    sectionTitles: DEFAULT_SECTION_TITLES,
    destinations: []
  }),
  actions: {
    async fetchHome() {
      this.loading = true;
      const [entryResult, curatedResult, destinationResult] =
        await Promise.allSettled([
          getHoteluxHomeEntries(),
          getHoteluxCuratedCollections(),
          getHoteluxPopularDestinations()
        ]);

      if (entryResult.status === "fulfilled") {
        const results = entryResult.value?.results || [];
        this.banners = results[0] || [];
        this.exclusiveOffers = results[1] || [];
      }

      if (curatedResult.status === "fulfilled") {
        const data = curatedResult.value || {};
        if (data.hotelIds?.length) {
          this.curatedHotelIds = data.hotelIds;
        }
        if (data.sectionTitles) {
          this.sectionTitles = data.sectionTitles;
        }
      }

      if (destinationResult.status === "fulfilled") {
        const data = destinationResult.value || {};
        this.destinations = data.destinations || [];
      }

      this.loading = false;
    }
  }
});

export function useHoteluxHomeStoreHook() {
  return useHoteluxHomeStore(store);
}
